import { render, staticRenderFns } from "./DistributionNew.vue?vue&type=template&id=7a21f776&scoped=true&"
import script from "./DistributionNew.vue?vue&type=script&lang=js&"
export * from "./DistributionNew.vue?vue&type=script&lang=js&"
import style0 from "./DistributionNew.vue?vue&type=style&index=0&id=7a21f776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21f776",
  null
  
)

export default component.exports